<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref,computed} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import { useCrmInstallData } from '../CrmInstallData';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const { getData } = useCrmInstallData();
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/status" }
	});
	const { errorMessage, isError, upgrade  } = useBaseStep(props);
	
	const maintenance = "../i/maintenance.jsp";
	const working = ref(false);
	const modeMessage = ref(msg('install.start'));
	const installError = ref(false);
	
	
	function runCrm() {
		window.location.href = props.form.frontUrl;
	}

	function checkStatus() {
		getData(props.restApi+props.endPoint)
			.then((data)=>{
				//console.log("data:"+JSON.stringify(data));
				if (data.working) {
					working.value = data.working;
				}
				if (data.modeMessage) {
					modeMessage.value = data.modeMessage;
				}
				if (data.installMode===127) {//install error
					installError.value = true;
				}
				if (data.errorMessage) {
					errorMessage.value = data.errorMessage;
				}
			});	
	}
	
	function checking() {
		checkStatus();
		if (!working.value) {
			setTimeout(checking, 3000);
		}
	}
	
	checking();
</script>
<template>
	<div>
	<table border="0" cellspacing="0" class="formTable" style="margin-left: 0px;">
		<tr>
			<td>
				<img :src="maintenance" width="150" alt="Maintenance"/>	
			</td>
			<td style="padding-top:10px">
				<template v-if="working">
					<div class="mainText">{{msg(upgrade?"upgrade.status.ok":"install.status.ok")}}</div>
					<br>
					<button @click="runCrm" class="button">
						<sym-icon name="checkmark-circle-16-full"/> {{msg("app.name")}}
					</button>
				</template>
				<template v-else-if="installError">
					<sym-icon name="warning-16"/>
					&nbsp;<span class="mainText">{{msg("install.status.error")}}</span>	
				</template>
				<template v-else>
					<sym-icon name="gear" class="uploadingIcon"/>
					&nbsp;<span class="mainText">{{modeMessage}}</span>	
				</template>
			</td>
		</tr>
		<tr>
			<td colspan="2"><error-msg :show="isError" :msg="errorMessage"/></td>
		</tr>
	</table>
	</div>
</template>


